import ProtectedRoute from "./components/ProtectedRoute.jsx";
import { Routes, Route, Navigate } from "react-router-dom";

import WebsiteRoute from "./route/WebsiteRoute.jsx";
import DashboardRoute from "./route/DashboardRoute.jsx";
import Login from "./pages/public/Login.jsx";
import ScrollToTop  from "./components/ScrollToTop.jsx"
import { Toaster } from "react-hot-toast";
import FloatingActions from "./components/FloatingActions.jsx";


function App() {
  return (
   <>
   <ScrollToTop />
   {/* Your routes */}
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
        }}
      />
      {/* <FloatingActions/> */}
    <Routes>
      
      {/* Public Website Routes */}
      <Route path="/*" element={<WebsiteRoute />} />

      {/* Protected Dashboard Routes */}
      <Route element={<ProtectedRoute />}>
        <Route path="/dashboard/*" element={<DashboardRoute />} />
      </Route>

      <Route path="/login" element={<Login />} />

    </Routes>
    </>
  );
}

export default App;
